<template>
  <el-dialog
    :model-value="true"
    custom-class="activit-new-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :width="noticeType === 1 ? '394px' : '620px'"
    :show-close="false"
  >
    <!-- 满足下述条件可显示券到账弹窗 -->
    <div v-if="activityId && noticeType === 1" class="relative">
      <img
        class="w-392px block"
        src="https://filecdn.hgj.com/joint-platform-web/insure/activit-new-customer-dialog-sucess-20241128.png"
        alt="#"
      />
      <div class="w-full activit-new-dialog__btn2">
        <div class="footer_btn left" @click="handleIKonw">
          {{ t('components.activityNew.iKnow') }}
        </div>
        <div class="footer_btn right" @click="handleToCouponCenter">
          {{ t('components.activityNew.check') }}
        </div>
      </div>
    </div>
    <div v-else class="relative">
      <img
        class="w-604px block"
        src="https://filecdn.hgj.com/joint-platform-web/insure/activit-new-customer-dialog-tip-20241128.png"
        alt="#"
      />
      <div class="activit-new-dialog__btn" @click="handleIKonw">
        {{ t('components.activityNew.iKnow') }}
      </div>
    </div>
  </el-dialog>
</template>
<script lang="ts" setup>
import { fetchActivityIkonw } from '@/api/activity'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
interface IProps {
  activityId?: string
  noticeType?: number
}
const props = defineProps<IProps>()
const emits = defineEmits(['resolve', 'reject'])

const handleClose = () => {
  emits('reject')
}
const handleConfirm = () => {
  emits('resolve')
}
const handleIKonw = async () => {
  if (props.activityId) {
    const { code } = await fetchActivityIkonw(props as Required<IProps>)
    if (code !== 200) return
  }
  handleConfirm()
}
const handleToCouponCenter = () => {
  const PREFIX = import.meta.env.VITE_APP_PREFIX_V2
  window.open(`https://${PREFIX}i.hgj.com/assets?tabName=experience`)
}
</script>
<style lang="scss">
.activit-new-dialog {
  --hep-dialog-padding-h: 0;
  --hep-bg-color-overlay: transparent;
  --hep-border-color-separator: transparent;
  --hep-box-shadow: transparent;
  &__btn {
    position: absolute;
    cursor: pointer;
    bottom: 49px;
    width: 240px;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    border: 1px solid #979797;
    transform: translateX(calc(50% + 60px));
    background: linear-gradient(270deg, #fd603c 0%, #ff3e3e 100%);
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    font-family: 'MiSans';
    text-align: center;
    letter-spacing: 2px;
  }
  &__btn2 {
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 60px;
    .footer_btn {
      width: 140px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      font-size: 20px;
      font-weight: 700;
      font-family: 'MiSans';
      letter-spacing: 0.83px;
      cursor: pointer;
    }
    .left {
      width: 140px;
      border-radius: 23px;
      border: 1px solid #f8d7ae;
      box-shadow:
        inset 0 0 3px 2px #ffffff80,
        0 2px 3px 0 #1f1a181a;
      margin-right: 20px;
      color: #f7d5ae;
    }
    .right {
      border-radius: 23px;
      border: 1px solid #f8d7ae;
      background: linear-gradient(
        137.7deg,
        #ffb887 0%,
        #fddc9d 48%,
        #f8d667 100%
      );
      box-shadow:
        inset 0 2px 3px 0 #ffffff80,
        0 2px 3px 0 #1f1a181a;
      color: #440916;
    }
  }
}
</style>
